import TechnologyDetailPage from "@/pages/technologies/components/TechnologyDetailPage";

export default function PhpTechPage() {
  return <TechnologyDetailPage slug="php" />;
}